module.exports = __webpack_public_path__ + "img/img-play8-fish.022c1571.png";